import { styled } from '@mui/material';

export const ContentModalHeaderContent = styled('div')(
  ({ align, hasCloseButton }: { align: 'left' | 'center' | 'right'; hasCloseButton: boolean }) => ({
    textAlign: align,
    paddingRight: hasCloseButton ? '2.5rem' : 0,
  }),
);

export const ContentModalHeaderClose = styled('div')({
  position: 'absolute',
  top: '0.75rem',
  right: '0.75rem',
});
